import React from "react";
import icon from "../pictures/icon.png";

const Indiaicon = () => {
  return (
    <>
      <div className="india_icon_container">
        <div className="india_icon_img">
          <img src={icon} alt="not" />
        </div>
        <p>
          The Global Icon Awards are coming in the 7th Year. Regarded as one of
          the most prestigious platform in the honour of the entrepreneurs,
          Innovators and Achievers, the Program is going to observe the
          participations from the various industry leaders and brands.
        </p>
        <p>
          This program is also a part of continued conversations with the
          leaders, to encourage and leverage the next generation entrepreneurs
          to experience the challenges and look for the out of box solutions.
        </p>
        <p>
          The awards felicitated at the program are determined by means of a
          comprehensive selection process that is based on ratings conducted by
          us from around the country.
        </p>

        <button>Register now</button>
      </div>
    </>
  );
};

export default Indiaicon;
